<template>
  <v-layout row wrap align-start align-content-start class="mb-2 preingest-home">
    <!-- Title and Tabs -->
    <v-flex xs12>
      <v-toolbar tabs color="secondary" class="elevation-0">
        <v-icon class="mr-0 indigo--text text--lighten-5">device_hub</v-icon>
        <v-toolbar-title class="white--text subheading ttu">
          {{ messages.label.PREINTEST }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <!-- Toolbar Tabs -->
        <v-toolbar-items class="tabs-extension">
          <v-tabs v-model="tab" color="secondary">
            <v-tabs-slider color="accent"></v-tabs-slider>
            <v-tab v-for="item in tabItems" :key="item" class="white--text">
              {{ item }}
            </v-tab>
            <v-spacer></v-spacer>
          </v-tabs>
        </v-toolbar-items>
      </v-toolbar>
    </v-flex>
    <!-- Main Content -->
    <v-layout>
      <v-flex xs12>
        <v-tabs-items v-model="tab">
          <v-tab-item>
            <ProcessingRecordsSearchFilter />
            <ProcessingRecordsSearchResult />
          </v-tab-item>
          <!-- NOTE: Hiding offers for MVP -->
          <!--<v-tab-item>
                <OffersSearchFilter />
                <OffersSearchResult />
              </v-tab-item>-->
          <v-tab-item>
            <BillingIdsSearch />
          </v-tab-item>
          <v-tab-item>
            <PreIngestErrors />
          </v-tab-item>
        </v-tabs-items>
      </v-flex>
    </v-layout>
    <!-- Snackbar -->
    <v-flex xs12>
      <v-snackbar :bottom="true" :timeout="snackbar.timeout" :color="snackbar.type" v-model="snackbar.show">
        {{ snackbar.message }}
        <v-btn flat color="primary" @click.native="snackbar.show = false">Ok</v-btn>
      </v-snackbar>
    </v-flex>
  </v-layout>
</template>

<script>
import ProcessingRecordsSearchFilter from "@/PreIngest/ProcessingRecords/ProcessingRecordsSearchFilter"
import ProcessingRecordsSearchResult from "@/PreIngest/ProcessingRecords/ProcessingRecordsSearchResult"
import OffersSearchFilter from "@/PreIngest/Offers/OffersSearchFilter"
import OffersSearchResult from "@/PreIngest/Offers/OffersSearchResult"
import PreIngestErrors from "@/PreIngest/Errors/PreIngestErrors"
import BillingIdsSearch from "@/PreIngest/BillingIds/BillingIdsSearch"
import messages from "@/PreIngest/messages.json"
import AppService from "@/AppService"
import PreIngestService from "@/PreIngest/PreIngestService"

export default {
  name: "PreIngestHome",
  components: {
    ProcessingRecordsSearchFilter,
    ProcessingRecordsSearchResult,
    OffersSearchFilter,
    OffersSearchResult,
    BillingIdsSearch,
    PreIngestErrors
  },
  data() {
    return {
      snackbar: {
        show: false,
        timeout: null,
        type: "error",
        message: ""
      },
      tab: null,
      tabItems: [
        // TODO: Add offer back when required  'Offers'
        "Processing Records",
        "Billing IDs",
        "Errors"
      ]
    }
  },
  created() {
    /**
     * Non reactive properties
     */
    this.messages = messages
    /**
     * Events
     * */
    AppService.$on("event:preIngestServerError", () => {
      this.snackbar.show = true
      this.snackbar.type = "error"
      this.snackbar.message = this.messages.error.SERVER_ERROR
    })

    PreIngestService.$on("event:showSnackBar", (snackBar) => {
      this.snackbar.show = true
      this.snackbar.type = snackBar.type
      this.snackbar.message = snackBar.msg
    })
  }
}
</script>

<style>
.preingest-home .tabs-extension {
  height: 48px;
}
</style>



// WEBPACK FOOTER //
// src/PreIngest/PreIngestHome.vue